export const OVERVIEW_CHART_COLORS = {
  datasetChanges: "#8C9BED",
  complianceActions: "#FB923C",
  noData: "#F7F7F8",
};
